export default __webpack_public_path__ + "static/media/resume.71de1048.pdf";